import { store } from "@store/storeConfig/store";
// ** Initial State
const initialState = {
  allSubTenants: [],
  allSubTenantsProperties: [],
  allReminders: [],
  total: 1,
  params: {},
  customTotal: null,
  token: JSON.parse(localStorage.getItem("accessToken")),
  getError: false,
  errorMsg: "Error occured!!",
  otpSuccess: false,
  setNewPassword: false,
  found_results: "",
  entries_per_page: "",
  total_results: "",
  fetching: false,
  updatePagination: 0,
  isTokenExpire: false,
};
// console.log(store)

// console.log('sssssssssssss', selectedUser)

const subtenants = (state = initialState, action) => {
  switch (action.type) {
    case "GET_ALL_SUBTENANTS":
      return {
        ...state,
        allSubTenants: action.data,
        customTotal: action.total,
        entries_per_page: action.entries_per_page,
        found_results: action?.found_results,
        total_results: action?.total_results,
      };
    case 'SET_ALL_SUBTENANTS_PROPERTY':
      return {
        ...state,
        allSubTenantsProperties: action.data
      }
    case 'DELETE_SUBTENANT_PROPERTIES':
      return {
        ...state,
        allSubTenantsProperties: action.data
      }
    case 'GET_ALL_REMINDERS': 
    return {
      ...state,
      allReminders: action.data,
      customTotal: action.total,
      entries_per_page: action.entries_per_page,
      found_results: action?.found_results,
      total_results: action?.total_results,
    };

    case "DELETE_SUBTENANT":
      // console.log(action.data)
      return { ...state, allSubTenants: action.data };
    case 'DELETE_REMINDER':
      return {...state, allReminders: action.data}
    case "GET_ERROR":
      return { ...state, getError: true, errorMsg: action.error };
    case "REMOVE_ERROR":
      return { ...state, getError: false, errorMsg: "" };
    default:
      return { ...state };
  }
};
export default subtenants;
